module.exports = __webpack_public_path__ + "static/media/brooks-leibee-27QcqVqgVg4-unsplash.3cee0b03.jpg";